import {Space, Tag} from "antd";

const TagList = ({tags}) => {
    return (
        <Space>
            {tags.map(t => <Tag key={t.title} closable onClose={t.onReset}>{t.title}: {t.value}</Tag>)}
        </Space>
    )
}

export default TagList;